import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../_dashboard/helpers'
import {useQueryRequest} from '../../user-management/users-list/core/QueryRequestProvider'
import {ClientsListToolbar} from './ClientsListToolbar'
import {useState, useEffect} from 'react'
import {useDebounce, initialQueryState} from '../../../../_dashboard/helpers'

type Props = {
  filters: {page: number; size: number; status: string; role: string}
  setFilters: React.Dispatch<
    React.SetStateAction<{page: number; size: number; status: string; role: string}>
  >
}

export const ClientsListHeader = ({filters, setFilters}: Props) => {
  const intl = useIntl()
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState('')
  const debouncedSearch = useDebounce(searchTerm, 200)

  useEffect(() => {
    updateState({search: debouncedSearch, ...initialQueryState})
  }, [debouncedSearch])

  return (
    <div className='card-header border-0 pt-6 pb-4 flex-wrap gap-3'>
      {/* Filters */}
      <div className='bo-filters d-flex flex-wrap gap-3 align-items-center flex-grow-1'>
        {/* Search */}
        <div className='position-relative d-flex align-items-center'>
          <KTSVG
            path='/media/icons/duotune/general/gen021.svg'
            className='svg-icon-2 position-absolute ms-4'
          />
          <input
            type='text'
            className='form-control form-control-solid w-200px w-lg-250px ps-12'
            placeholder={intl.formatMessage({id: 'COMMON.SEARCH'})}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Status */}
        <select
          className='form-select form-select-solid w-auto min-w-140px'
          value={filters.status}
          onChange={(e) => setFilters((f) => ({...f, page: 0, status: e.target.value}))}
        >
          <option value=''>{intl.formatMessage({id: 'USERS.FILTER.ALL_STATUS'})}</option>
          <option value='ACTIVE'>{intl.formatMessage({id: 'USERS.STATUS.ACTIVE'})}</option>
          <option value='INACTIVE'>{intl.formatMessage({id: 'USERS.STATUS.INACTIVE'})}</option>
        </select>
      </div>

      {/* Toolbar */}
      <div className='card-toolbar ms-auto'>
        <ClientsListToolbar filters={filters} />
      </div>
    </div>
  )
}
